(function () {
  function getSelected(modal) {
    return modal.querySelector('.creatine-variant-option input[type="radio"]:checked');
  }

  function syncSelected(modal) {
    modal.querySelectorAll('.creatine-variant-option').forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      label.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function updateAddBtn(modal) {
    var btn = modal.querySelector('[data-creatine-add-to-cart]');
    var selected = getSelected(modal);
    if (!btn || !selected) return;
    var suffix = btn.getAttribute('data-suffix') || '';
    var text = 'ADD ' + selected.getAttribute('data-title') + ' · ' + selected.getAttribute('data-price') + ' ' + suffix;
    btn.textContent = text.trim();
  }

  function openModal(modal) {
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    syncSelected(modal);
    updateAddBtn(modal);
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.setAttribute('hidden', true);
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    // Open
    var openBtn = e.target.closest('[data-creatine-modal-open]');
    if (openBtn) {
      var modal = document.getElementById(openBtn.getAttribute('data-creatine-modal-open'));
      if (modal) openModal(modal);
      return;
    }

    // Close
    var closeEl = e.target.closest('[data-creatine-modal-close]');
    if (closeEl) {
      var parentModal = closeEl.closest('.creatine-modal');
      if (parentModal) closeModal(parentModal);
      return;
    }

    // Add to cart
    var addBtn = e.target.closest('[data-creatine-add-to-cart]');
    if (addBtn) {
      var cartModal = addBtn.closest('.creatine-modal');
      var selected = getSelected(cartModal);

      if (!selected) {
        alert('Please select an option');
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: selected.value, quantity: 1 }]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          addBtn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            closeModal(cartModal);
            addBtn.disabled = false;
            updateAddBtn(cartModal);
          }, 1000);
        })
        .catch(function (error) {
          alert(error.message);
          addBtn.disabled = false;
          updateAddBtn(cartModal);
        });
    }
  });

  // Variant change
  document.addEventListener('change', function (e) {
    if (e.target.matches('.creatine-variant-option input[type="radio"]')) {
      var modal = e.target.closest('.creatine-modal');
      if (modal) {
        syncSelected(modal);
        updateAddBtn(modal);
      }
    }
  });

  // ESC to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.creatine-modal:not([hidden])').forEach(closeModal);
    }
  });
})();